<template>
  <div class="ns-product-detail-info" :content-type="contentType">
    <h3 class="ns-product-detail-info__title">{{ title }}</h3>
    <div
      class="ns-product-detail-info__body"
      v-html="content.replace('<p>&nbsp;</p>', '')"
    />
  </div>
</template>

<script>
export default {
  name: "NsProductDetailInfo",
  props: {
    /**
     * Title of the section content
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * HTML content of the section
     */
    content: {
      type: String,
      default: ""
    },
    /**
     * Enum type of content to aid in styling the section
     * "videos", "benefits", "usage", "ingredients", "resources"
     */
    contentType: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use '~@nuskin/ns-core-styles/src/scss/colors';
@use '~@nuskin/ns-core-styles/src/scss/typographyVariables';

::-moz-selection {
  background: map.get(colors.$themeColors, color-interactive-5);
}
::selection {
  background: map.get(colors.$themeColors, color-interactive-5);
}
.ns-product-detail-info {
  font-size: 16px;
  line-height: 21px;
  font-family: map.get(typographyVariables.$typography, font-family-primary);
  color: map.get(colors.$themeColors, color-interactive-7);
  padding: 30px;
  background-color: map.get(colors.$themeColors, color-background-1);
}
.ns-product-detail-info__title {
  font-weight: map.get(typographyVariables.$typography, font-weight-normal);
  font-size: 28px;
  line-height: 34px;
  margin-bottom: 20px;
}
.ns-product-detail-info__body ::v-deep a {
  display: inline-block;
  margin-bottom: 20px;
  text-decoration: none !important;
}
.ns-product-detail-info__body ::v-deep h4 {
  font-size: 16px;
  line-height: 18px;
  font-weight: map.get(typographyVariables.$typography, font-weight-semibold);
  margin-bottom: 10px;
}
.ns-product-detail-info__body ::v-deep p {
  margin-bottom: 30px;
}
.ns-product-detail-info__body ::v-deep ul {
  display: grid;
  grid-gap: 10px;
  padding-inline-start: 30px;
  list-style: disc;
}
.ns-product-detail-info__body ::v-deep b {
  font-weight: map.get(typographyVariables.$typography, font-weight-semibold);
}
.ns-product-detail-info__body ::v-deep p > a,
.ns-product-detail-info__body ::v-deep li > a,
.ns-product-detail-info__body ::v-deep .text > a {
  color: map.get(colors.$themeColors, color-interactive-7);
  font-weight: map.get(colors.$themeColors, font-weight-semibold);
  border-bottom: 1px solid currentColor;
}
.ns-product-detail-info__body ::v-deep video,
.ns-product-detail-info__body ::v-deep iframe {
  max-width: 100%;
}
.ns-product-detail-info[content-type="videos"]
  .ns-product-detail-info__body
  ::v-deep
  p {
  width: 100%;
  max-width: 100%;
  position: relative;
}
.ns-product-detail-info:not([content-type="videos"])
  .ns-product-detail-info__body
  > ::v-deep
  * {
  max-width: 550px;
}
.ns-product-detail-info__body ::v-deep video.aem-video {
  background: black;
}

.ns-product-detail-info__body > ::v-deep *:last-child {
  margin-bottom: 0;
}

.ns-product-detail-info {
  ::v-deep div:empty,
  ::v-deep span:empty,
  ::v-deep h3:empty {
    display: none;
  }
}
@media (max-width: 1023px) {
  .ns-product-detail-info:not([content-type="videos"])
    .ns-product-detail-info__body
    > ::v-deep
    * {
    width: auto;
  }
}
</style>
